import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import LineChart from "./Charts/LineChart";
import CandleChart from "./Charts/CandleChart";
import { useDispatch } from "react-redux";
import {
  getAssignmentSectionCounts,
  fileCompleteChartStats,
  getOrganizationsLatestUploads,
  fileCandleChartData,
  errorWatchLogs
} from "../../context/actions/dashboardStats"
import Footer from "../../components/LiveStatsFooter/Footer";
import Listing from "./Listing";
import { SocketContext } from "../../context/actions/socket";

const DashboardliveStats = () => {
  const { backendSocket, socket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const [orgUploads, setOrgUploads] = useState([])
  const [assignmentCounts, setAssignmentCounts] = useState({});
  const [errorWatchCounts,setErrorWatchCounts] = useState(null);
  const [filesEventCompleted, setFilesEventCompleted] = useState({});
  const [candleData, setCandleData] = useState({});
  

  const fetchData = async (retryCount = 3) => {
    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await Promise.all([
        new Promise((resolve, reject) => {
          dispatch(getAssignmentSectionCounts({}, (res) => {
            if (res) {
              setAssignmentCounts(res);
              resolve();
            } else {
              reject();
            }
          }));
        }),
        new Promise((resolve, reject) => {
          dispatch(fileCompleteChartStats({ timezone: userTimezone }, (res) => {
            if (res) {
              setFilesEventCompleted(res);
              resolve();
            } else {
              reject();
            }
          }));
        }),
        new Promise((resolve, reject) => {
          dispatch(fileCandleChartData({ timezone: userTimezone }, (res) => {
            if (res) {
              setCandleData(res);
              resolve();
            } else {
              reject();
            }
          }));
        }),
        new Promise((resolve, reject) => {
          dispatch(errorWatchLogs({}, (res) => {
            if (res) {
              setErrorWatchCounts(res?.length);
              resolve();
            } else {
              reject();
            }
          }));
        })
      ]);
    } catch (error) {
      if (retryCount > 0) {
        console.error(`Fetch failed, retrying... (${retryCount} retries left)`);
        setTimeout(() => fetchData(retryCount - 1), 2000);
      } else {
        console.error("Fetch failed after multiple retries:", error);
      }
    }
  };
  useEffect(() => { 
    document.body.classList.add('main_roots');
    dispatch(getOrganizationsLatestUploads((res)=> {
      setOrgUploads(res);
    }))
    backendSocket.off('organization-monitoring-data').on('organization-monitoring-data', (res, err) => {
			if (res) {
				setOrgUploads(res)
			}
		})
    return () => {
        document.body.classList.remove('main_roots');
    };
}, []);

  const scheduleFetchData = () => {
    const now = new Date();
    const estOffset = -5;
    const estNow = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }));
    const nextMidnight = new Date(estNow);
    nextMidnight.setHours(24, 0, 0, 0); 

    const timeUntilMidnight = nextMidnight - estNow;

    setTimeout(() => {
      fetchData(); 
      setInterval(fetchData, 24 * 60 * 60 * 1000); 
    }, timeUntilMidnight);
  };

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 5 * 60 * 1000); 

    return () => clearInterval(intervalId);
  }, []);


  return (
    <>
     
        <div className="dashboard-stats-wrapper">
          <div className="new-dashboard-header d-flex justify-content-between align-items-center mb-2">
            <div className="work-logo-div ">
              <img
                className="logo-new"
                src={require("../../assets/img/app-logo2.svg")}
                alt="logo-new"
              />
            </div>
            <div className="work-logo-div text-end">
              <img
                className="dashboard-main-logo"
                src={require("../../assets/img/Main_Logo.png")}
                alt="logo-new"
              />
            </div>
          </div>
          <div className="main-assessment-div assignment_que">
            <div className="row">
              <div className="col-md-4 mb-4" >
                <div className="assignment-div">
                  <div className="assignment-header">
                    <h5 className="m-0">Assignment Queue: 7-Day Recap</h5>
                  </div>
                  <div className="assessment-content">
                    <div className="files-div d-flex justify-content-between align-items-center">
                      <div className="icon-file d-flex gap-4">
                        <h5 className="light-text">{assignmentCounts?.totalUnassignedFiles || 0}</h5>
                        <p className="m-0"><h5>Documents Unassigned</h5></p>
                        {assignmentCounts?.totalPurchaseUnassignedFiles > 0 ?
                          <span style={{ color: 'red' }}>
                            *{assignmentCounts?.totalPurchaseUnassignedFiles} New Purchase Advices have been Uploaded *
                          </span>
                        : null}
                      </div>
                      <div>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={assignmentCounts?.totalFiles ? (assignmentCounts?.totalUnassignedFiles / assignmentCounts?.totalFiles) * 100 : 0} // Dynamic percentage for unassigned files
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div className="progress-bar" style={{ width: `${assignmentCounts?.totalFiles ? (assignmentCounts?.totalUnassignedFiles / assignmentCounts?.totalFiles) * 100 : 0}%` }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="assessment-content">
                    <div className="files-div d-flex justify-content-between align-items-center">
                      <div className="icon-file d-flex gap-4">
                        <h5 className="bold-text">{assignmentCounts?.totalAssignedFiles || 0}</h5>
                        <p className="m-0"><h5>Documents Assigned</h5></p>
                      </div>
                      <div>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={assignmentCounts?.totalFiles ? (assignmentCounts?.totalAssignedFiles / assignmentCounts?.totalFiles) * 100 : 0} // Dynamic percentage for assigned files
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div className="progress-bar" style={{ width: `${assignmentCounts?.totalFiles ? (assignmentCounts?.totalAssignedFiles / assignmentCounts?.totalFiles) * 100 : 0}%` }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="assessment-content total_errors_queue">
                    <div className="files-div d-flex justify-content-between align-items-center">
                      <div className="icon-file d-flex gap-4">
                        <h5 className="light-text">{errorWatchCounts || 0}</h5>
                        <p className="m-0"><h5>Error Watch count</h5></p>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                  <div className="assessment-content total_errors_queue">
                    <div className="files-div d-flex justify-content-between align-items-center">
                      <div className="icon-file d-flex gap-4">
                        <h5 className="light-text">{assignmentCounts?.totalErrorFiles || 0}</h5>
                        <p className="m-0"><h5>Documents in Triage</h5></p>
                        {assignmentCounts?.totalPurchaseTriagedFiles > 0 ?
                          <span style={{ color: 'red' }}>
                            *{assignmentCounts?.totalPurchaseTriagedFiles} Purchase Advices in Triage *
                          </span>
                        : null}
                        {assignmentCounts?.totalTriageQueueInternalServerErrors >= 50 ?
                          <span style={{ color: 'red',fontStyle: 'italic' , position: 'relative', top: '-10px' }}> 
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path
                              d="M22.25 17.2499L14.165 3.24989C13.9455 2.86987 13.63 2.55431 13.2499 2.3349C12.8699 2.1155 12.4388 2 12 2C11.5612 2 11.1301 2.1155 10.75 2.3349C10.37 2.55431 10.0544 2.86987 9.83498 3.24989L1.74998 17.2499C1.53047 17.6301 1.41495 18.0614 1.41504 18.5004C1.41512 18.9394 1.53081 19.3706 1.75046 19.7507C1.97011 20.1308 2.28598 20.4464 2.6663 20.6657C3.04661 20.885 3.47797 21.0002 3.91698 20.9999H20.083C20.5218 20.9999 20.9529 20.8844 21.333 20.6649C21.713 20.4455 22.0286 20.1299 22.248 19.7499C22.4674 19.3698 22.5829 18.9387 22.5829 18.4999C22.5829 18.061 22.4674 17.6299 22.248 17.2499H22.25Z"
                              fill="url(#paint0_linear)"
                            />
                            <path
                              d="M12 15C12.262 15.0012 12.515 14.9044 12.7092 14.7286C12.9035 14.5529 13.0251 14.3108 13.05 14.05L13.64 8.15C13.661 7.94121 13.6379 7.73033 13.5723 7.53101C13.5067 7.33168 13.4 7.14834 13.2591 6.99284C13.1182 6.83733 12.9462 6.71312 12.7543 6.62822C12.5624 6.54333 12.3548 6.49965 12.145 6.5H11.855C11.6454 6.5 11.4381 6.54394 11.2464 6.62898C11.0548 6.71403 10.8832 6.8383 10.7426 6.99376C10.6019 7.14923 10.4954 7.33245 10.43 7.5316C10.3645 7.73076 10.3415 7.94142 10.3625 8.15L10.9525 14.05C10.9774 14.3104 11.0986 14.5521 11.2923 14.7278C11.4861 14.9035 11.7384 15.0006 12 15Z"
                              fill="url(#paint1_linear)"
                            />
                            <path
                              d="M12 19C12.9665 19 13.75 18.2165 13.75 17.25C13.75 16.2835 12.9665 15.5 12 15.5C11.0335 15.5 10.25 16.2835 10.25 17.25C10.25 18.2165 11.0335 19 12 19Z"
                              fill="url(#paint2_linear)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear"
                                x1="6.06698"
                                y1="10.1679"
                                x2="21.0135"
                                y2="20.6944"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#FED200" />
                                <stop offset="1" stopColor="#F59815" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear"
                                x1="10.159"
                                y1="7.794"
                                x2="13.775"
                                y2="13.0575"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3E4154" />
                                <stop offset="1" stopColor="#1B2129" />
                              </linearGradient>
                              <linearGradient
                                id="paint2_linear"
                                x1="10.8895"
                                y1="16.1395"
                                x2="13.038"
                                y2="18.288"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3E4154" />
                                <stop offset="1" stopColor="#1B2129" />
                              </linearGradient>
                            </defs>
                          </svg>
                             Check TRIAGE QUEUE FOR INTERNAL SERVER ERRORS
                          </span>
                        : null}
                      </div>
                    </div>
                  </div>
                  <div className="assessment-content">
                    <div className="files-div d-flex justify-content-between align-items-center">
                      <div className="icon-file d-flex gap-4">
                        <h5 className="light-text">{assignmentCounts?.totalQaFilesToday || 0}</h5>
                        <p className="m-0"><h5>Documents in QA</h5></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col"><Listing organization={orgUploads}/></div>
              </div>
              <div className="col-md-8">                
              <div className="col-md-12">
                <div className="assignment-div-chart" style={{ marginBottom: '20px' }}>
                  <div className="assignment-chart">
                    {filesEventCompleted ? <LineChart daysEvent={filesEventCompleted} /> : <p>No data available</p>}
                  </div>
                </div>
                <div className="assignment-div-chart">
                  <div className="assignment-chart">
                    {Object.keys(candleData).length ? <CandleChart candleData={candleData} /> : <p>No data available</p>}
                  </div>
                </div>
              </div>
              </div>
              
            </div>
          </div>
          <div className="live-footer">
            <Footer />
          </div>
        </div>
      
    </>
  );
};

export default DashboardliveStats;
